<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
          パターン
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">パターン</a>
          </li>
      </ul>
    </div>
    <b-card v-if="show">
      <b-row>
        <b-col>
          パターン
        </b-col>
      </b-row>
      <hr>

      <b-card v-show="so.adv">
        <b-row>
          <b-col>
            <b-form-group label="Webシェルカテゴリー" label-for="code_category" v-b-tooltip.hover >
              <b-form-checkbox-group v-model="so.opt.category">
                <b-button size="sm" variant="primary" @click="so.opt.category=[]"> 初期化 </b-button>
                <b-form-checkbox :value="'-'">未分類</b-form-checkbox>
                <b-form-checkbox :value="'2'">Webシェル</b-form-checkbox>
                <b-form-checkbox :value="'3'">スパムメール</b-form-checkbox>
                <b-form-checkbox :value="'4'">ファイルマネージャー</b-form-checkbox>
                <b-form-checkbox :value="'5'">ランサムウェア</b-form-checkbox>
                <b-form-checkbox :value="'6'">悪意ある攻撃</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="ファイルの拡張子名" label-for="code_ext" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt.ext">
                <b-button size="sm" variant="primary" @click="so.opt.ext=[]"> 初期化 </b-button>
                <b-form-checkbox :value="'1'">未分類</b-form-checkbox>
                <b-form-checkbox :value="'2'">CGI実行ファイル</b-form-checkbox>
                <b-form-checkbox :value="'3'">JSP/WAR</b-form-checkbox>
                <b-form-checkbox :value="'4'">NodeJS</b-form-checkbox>
                <b-form-checkbox :value="'5'">ASP/ASPX</b-form-checkbox>
                <b-form-checkbox :value="'6'">PHP</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="検出方法" label-for="code_type" v-b-tooltip.hover>
              <b-form-checkbox-group v-model="so.opt.type">
                <b-button size="sm" variant="primary" @click="so.opt.type=[]"> 初期化 </b-button>
                <b-form-checkbox :value="'1'">正規表現</b-form-checkbox>
                <b-form-checkbox :value="'2'">SSDEEP</b-form-checkbox>
                <b-form-checkbox :value="'3'">ファイルハッシュ</b-form-checkbox>
                <b-form-checkbox :value="'4'">URL</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="利用状況">
              <b-form-radio-group id="radio-group-2" v-model="so.opt.is_alive" v-b-tooltip.hover title="検索したい利用状況を入力してください">
                <b-form-radio :value="true" @click="so.sv=`is_alive`">使用済み</b-form-radio>
                <b-form-radio :value="false" @click="so.sv=`is_alive`">無効</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group label="コード" label-for="ph_code" v-b-tooltip.hover title="検索したいコードを入力してください">
              <b-form-input v-model="so.sv" @click="so.sk='code';"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            登録はこちら
            <b-form>
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="4">
            登録へ
            <b-form>
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh" > 検索 </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> リセット </b-button>
          <b-button size="sm" variant="default" @click="so.adv = false"> キャンセル </b-button>
        </b-form-group>
      </b-card>

      <b-row>
        <b-col sm="6">
          <!-- <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" /> -->
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-input-group-text size="sm" variant="outline-secondary">コード</b-input-group-text>

            </b-input-group-prepend>
            <b-form-input v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary"  @click="so.adv = true"><i :class="'fa ' + (so.adv ? 'fa-search-minus' : 'fa-search-plus')"></i></b-btn>
              <!-- <b-btn variant="outline-secondary" v-show="so.adv" @click="so.adv = false"><i class="fa fa-search-minus"></i></b-btn> -->
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" class="table-responsive table_add"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="category" slot-scope="row">{{codes.code_category[row.item.category]}}</template>
        <template slot="ext" slot-scope="row">{{codes.code_ext[row.item.ext]}}</template>
        <template slot="type" slot-scope="row">{{codes.code_type[row.item.type]}}</template>
        <template slot="code" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            {{row.item.code | truncate(80) }}
          </a>
        </template>
        <template slot="source" slot-scope="row">{{row.item.source}}</template>
        <template slot="is_alive" slot-scope="row">
          <b-badge v-if="row.item.is_alive == true" variant="success">使用済み</b-badge>
          <b-badge v-else>無効</b-badge>
        </template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">詳細</b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col md="4"></b-col>
        <b-col md="4">
          <b-pagination size="sm"  align="center" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
        <b-col md="4">
          <div class="pull-right">
            <b-button size="sm" variant="success" @click="$router.push({ name: 'wsfinder_pattern', params: { id : 'add' }})" class="btn-add"> 新規登録 </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
